// Validates the return_to redirect target carried on /login, /tenant, and
// /switch (design §3.14 steps 2 and 7). Only absolute https targets on a
// *.daricestrategies.com subdomain are honored; everything else is rejected so
// the portal can never be used as an open redirector.
export function resolveReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  if (!url.hostname.endsWith('.daricestrategies.com')) return null;
  return url.toString();
}

// Where a login flow lands when no usable return_to was carried (direct
// visits to the portal, older deployed logout links). 2026-07-28: signing in
// without a return_to stranded Christian on the portal instead of the app.
export const DEFAULT_RETURN_TO = 'https://app.daricestrategies.com/';
